export const options = {
  title: 'Shifts per Client',
  titleTextStyle: {
    fontSize: 20,
  },
  vAxis: { minValue: 0 },
  curveType: "function",
  chart: {
    title: "Company Performance",
  },
  // legend: { position: "bottom", maxLines: 2 },
};

export const optionChart = {
  title: 'Shifts per Client',
  titleTextStyle: {
    fontSize: 20,
  },
}

export const optionsPieChart = {
  legend: "none",
  titleTextStyle: {
    fontSize: 20,
  },
  vAxis: { minValue: 0 },
  pieSliceText: "label",
  curveType: "function",
  title: "Shifts per Client",
}

export const optionsStatusPieChart = {
  title: 'Status Distribution',
  titleTextStyle: {
    fontSize: 18,
  },
  legend: "none",
  pieSliceText: "label",
  colors: ['#74C365','#F7DE3A', '#FF0000',],
  pieHole: 0.6
}
